﻿import type { IFetcher } from "../../util/io/Fetcher";
import type { GetResourcesResponseModel } from "../../../OpenApi/api";

export interface IResourcesFetcher {
    fetch(): Promise<GetResourcesResponseModel>;

    setLanguage(language: string): Promise<void>;
}

export class ResourcesFetcher implements IResourcesFetcher {
    constructor(
        private readonly fetcher: IFetcher,
        private readonly version: string,
    ) {}

    async fetch(): Promise<GetResourcesResponseModel> {
        const { fetcher } = this;
        const url = "/POW4/Resources/GetResources?v=" + this.version;
        return await fetcher.getJSON<GetResourcesResponseModel>(url);
    }

    async setLanguage(language: string): Promise<void> {
        const { fetcher } = this;
        const url = "/POW4/Resources/SetLanguage";
        return await fetcher.postJSON<void>(url, {
            language: language,
        });
    }
}
